//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
  export default {
    scrollToTop: true,
    props: {
      error: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        x: 0,
        y: 0
      }
    },
    computed: {
    },
    mounted () {
      if (window.innerWidth > 980) {
        // document.addEventListener('mousemove', this.move)
        this.$refs.errorContainer.addEventListener('mousemove', this.move)
      } else {
        this.$refs.errorTop.style.clipPath = 'none'
      }
      disableBodyScroll();
    },
    beforeDestroy () {
      // document.removeEventListener('mousemove', this.move)
      enableBodyScroll();
      this.$refs.errorContainer.removeEventListener('mousemove', this.move)
    },
    methods: {
      move (e) {
        // this.x = e.pageX
        // this.y = e.pageY
        this.x = e.layerX
        this.y = e.layerY
      }
    }
  }
